import React, { useState } from 'react'
import { useHistory } from 'react-router-dom'
import { useApiListAssetUnityPackage } from '../../../../../../api-new/state/content'
import { BreadcrumbView } from '../../../../../../context/breadcrumb.context'
import { CardFullHeightScrollY } from '../../../../../../shared/card/card-full-height-scroll-y'
import { IconFile } from '../../../../../../shared/icon/icon'
import { ErrorReference } from '../../../../../../shared/error/error-reference'
import { serverMessage } from '../../../../../../shared/error/server-message'
import { LibraryMenu } from '../../common/menu/node-actions'
import '../../../../../../shared/sso-workspace/sso-workspace.scss'

// "Add Unity package" (internal tools), a page so the library item's ⋮ menu
// offers it the same way from the item's card and from its page: adds an
// empty Unity package to the item, then goes back to the item's page, where
// the file is uploaded into it (its list reloads when the page is shown
// again).
export const NodeLibraryAddUnityPackage = ({ parentURL, nodeID }) => {
  const history = useHistory()
  const apiListAssetUnityPackage = useApiListAssetUnityPackage()

  const [busy, setBusy] = useState(false)
  const [failure, setFailure] = useState(null)

  const handleAdd = async () => {
    setBusy(true)
    setFailure(null)
    try {
      await apiListAssetUnityPackage.post({ nodeID, name: 'file' })
      history.push(parentURL)
    } catch (err) {
      setFailure({ message: serverMessage(err, "We couldn't add the Unity package. Try again in a moment."), error: err })
      setBusy(false)
    }
  }

  const HeaderMenu = () => <LibraryMenu place="header" url={parentURL} />

  return (
    <BreadcrumbView Icon={IconFile} text="Add Unity package">
      <CardFullHeightScrollY title="Add Unity package" HeaderMenu={HeaderMenu}>
        <div className="sw-workspace py-2">
          <p>Adds an empty Unity package to this library item. Upload its file on the item's page.</p>
          {failure &&
            <p className="text-danger mb-1" role="alert">
              {failure.message}
            </p>}
          {failure && <ErrorReference error={failure.error} className="mb-3" />}
          <div className="d-flex flex-wrap gap-2">
            <button type="button" className="btn sw-btn" onClick={() => history.push(parentURL)}>
              Cancel
            </button>
            <button type="button" className="btn sw-btn-primary" disabled={busy} onClick={handleAdd}>
              {busy ? 'Adding…' : 'Add Unity package'}
            </button>
          </div>
        </div>
      </CardFullHeightScrollY>
    </BreadcrumbView>
  )
}
